export default __webpack_public_path__ + "static/media/avatar_22.83f31ffc.png";